import { useState } from 'react';
import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/articles';

const ARTICLES_PER_PAGE = 9;

export default function ArticleCards() {
  const [visibleCount, setVisibleCount] = useState(ARTICLES_PER_PAGE);

  const visibleArticles = featuredArticles.slice(0, visibleCount);
  const hasMore = visibleCount < featuredArticles.length;

  const loadMore = () => {
    setVisibleCount((prev) => Math.min(prev + ARTICLES_PER_PAGE, featuredArticles.length));
  };

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="text-center mb-12">
          <p className="text-xs tracking-[0.2em] uppercase text-primary-600 font-label mb-3">Guide & Approfondimenti</p>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-3">
            Tutte le Guide Itaobuy Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[600px] mx-auto">
            Esplora la nostra raccolta di {featuredArticles.length} guide SEO originali in italiano: brand, strategie, sicurezza e molto altro.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {visibleArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/articoli/${article.slug}`}
              className="group bg-white border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="h-44 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="inline-block text-[11px] tracking-[0.15em] uppercase text-primary-600 font-label mb-2 px-2.5 py-1 rounded-full bg-primary-50">
                  {article.tag}
                </span>
                <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-2 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <div className="w-5 h-5 rounded-full bg-secondary-200 flex items-center justify-center">
                    <span className="text-[9px] font-bold text-secondary-600">MR</span>
                  </div>
                  <span>{article.author}</span>
                  <span>·</span>
                  <span>{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {hasMore && (
          <div className="mt-10 text-center">
            <button
              onClick={loadMore}
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Carica altre guide
              <i className="ri-arrow-down-line"></i>
            </button>
            <p className="text-xs text-foreground-500 mt-3">
              {visibleCount} di {featuredArticles.length} articoli mostrati
            </p>
          </div>
        )}
      </div>
    </section>
  );
}